var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app2"}},[_c('sidebar',{attrs:{"mokid":_vm.mokid},on:{"menu-selected":_vm.updateSelectedMenu}}),_c('content-area',{attrs:{"selected-menu":_vm.selectedMenu,"mokid":_vm.mokid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }